import { createStore } from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agentCapacityPolicies from './modules/agentCapacityPolicies';
import agents from './modules/agents';
import assignmentPolicies from './modules/assignmentPolicies';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auditlogs from './modules/auditlogs';
import auth from './modules/auth';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import documentTemplates from './modules/documentTemplates';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customRole from './modules/customRole';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import draftMessages from './modules/draftMessages';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import knowledgeSources from './modules/knowledgeSources';
import labels from './modules/labels';
import macros from './modules/macros';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import slaReports from './modules/SLAReports';
import summaryReports from './modules/summaryReports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import workflows from './modules/workflows';
import captainAssistants from './captain/assistant';
import captainDocuments from './captain/document';
import captainResponses from './captain/response';
import captainInboxes from './captain/inboxes';
import captainBulkActions from './captain/bulkActions';
import copilotThreads from './captain/copilotThreads';
import copilotMessages from './captain/copilotMessages';
import captainScenarios from './captain/scenarios';
import captainTools from './captain/tools';
import captainCustomTools from './captain/customTools';
import aiAgentBrains from './ai_agents/brains';
import aiAgentVersions from './ai_agents/versions';
import aiAgentDeploys from './ai_agents/deploys';
import aiAgentTools from './ai_agents/tools';
import ticketConversations from './modules/ticketConversations';
import appBuilder from './modules/appBuilder';
import ticketTypingStatus from './modules/ticketTypingStatus';
import tickets from './modules/tickets';
import tasks from './modules/tasks';
import issueClusters from './modules/issueClusters';
import issueClusterSuggestions from './modules/issueClusterSuggestions';
import tramites from './modules/tramites';
import tramiteTypes from './modules/tramiteTypes';
import empresas from './modules/empresas';
import empresaNotes from './modules/empresaNotes';
import clusters from './modules/clusters';
import clusterMemberships from './modules/clusterMemberships';
import clusterTypes from './modules/clusterTypes';
import projects from './modules/projects';
import playbooks from './modules/playbooks';
import projectNotes from './modules/projectNotes';
import projectMembers from './modules/projectMembers';
import projectContacts from './modules/projectContacts';

const plugins = [];

export default createStore({
  modules: {
    accounts,
    agentBots,
    agentCapacityPolicies,
    agents,
    assignmentPolicies,
    articles,
    attributes,
    auditlogs,
    auth,
    automations,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    documentTemplates,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customRole,
    customViews,
    dashboardApps,
    draftMessages,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    knowledgeSources,
    labels,
    macros,
    notifications,
    portals,
    reports,
    sla,
    slaReports,
    summaryReports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    workflows,
    captainAssistants,
    captainDocuments,
    captainResponses,
    captainInboxes,
    captainBulkActions,
    copilotThreads,
    copilotMessages,
    captainScenarios,
    captainTools,
    captainCustomTools,
    aiAgentBrains,
    aiAgentVersions,
    aiAgentDeploys,
    aiAgentTools,
    ticketConversations,
    appBuilder,
    ticketTypingStatus,
    tickets,
    tasks,
    issueClusters,
    issueClusterSuggestions,
    tramites,
    tramiteTypes,
    empresas,
    empresaNotes,
    clusters,
    clusterMemberships,
    clusterTypes,
    projects,
    playbooks,
    projectNotes,
    projectMembers,
    projectContacts,
  },
  plugins,
});
